import { getSections } from "@/pages/human-resources/time-management/endpoints/reference/domain/SectionsEndpoint.ts";
import { getPositions } from "@/pages/human-resources/time-management/endpoints/reference/domain/PositionsEndpoint.ts";
import { getRoles } from "@/pages/human-resources/time-management/endpoints/reference/domain/RolesEndpoint.ts";
import {
  getDomainDailyTags,
  getHourlyTags,
} from "@/pages/human-resources/time-management/endpoints/tags/ScheduleTagsEndpoints.ts";
import { getDomainScheduleTemplates } from "@/pages/human-resources/time-management/endpoints/schedules/templates/ScheduleTemplatesEndpoints.ts";
import type { DomainScheduleReferenceDataOut } from "@/pages/human-resources/time-management/endpoints/reference/domain/inout/DomainScheduleReferenceDataOut.ts";

export default async function loadDomainScheduleReferenceData(
  domainId: string,
): Promise<DomainScheduleReferenceDataOut> {
  const [
    sectionsOut,
    positionsOut,
    rolesOut,
    hourlyTagsOut,
    scheduleTemplatesOut,
    dailyTagsOut,
  ] = await Promise.all([
    getSections(domainId),
    getPositions(domainId),
    getRoles(domainId),
    getHourlyTags(domainId),
    getDomainScheduleTemplates(domainId),
    getDomainDailyTags(domainId),
  ]);
  return {
    domainId,
    sectionsOut,
    positionsOut,
    rolesOut,
    hourlyTagsOut,
    templatesOut: scheduleTemplatesOut,
    dailyTagsOut,
  };
}
